import { styled } from '@mui/material';
import { memo } from 'react';
import { Dialog } from 'shell/components/Dialog';
import IconButton from 'shell/components/IconButton';

const VideoDialog = memo(({ videoId, ...rest }) => {
    return (
        <CustomDialog {...rest}>
            <CustomIconButton
                aria-label={'close video'}
                kind={'exit'}
                size={'medium'}
                variant={'circle'}
                onClick={rest.onClose}
            />
            <iframe
                width={'100%'}
                height={'100%'}
                src={`https://www.youtube.com/embed/${videoId}`}
                allow={'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}
                allowFullScreen
                title={'Embedded YouTube Video'}
            />
        </CustomDialog>
    );
});

const CustomDialog = styled(Dialog)(({ theme }) => {
    return {
        '& .MuiDialog-paper': {
            borderRadius: 0,
            margin: 0,
            maxWidth: '968px',
            width: '100%',
            padding: theme.spacing(8),
            aspectRatio: '16 / 10',
            background: 'transparent',
            overflow: 'hidden',
        },
        '& .MuiBox-root': {
            height: '100%',
            padding: 0,
        },
        '& iframe': {
            border: 0,
        },
    };
});

const CustomIconButton = styled(IconButton)(() => {
    return {
        position: 'absolute',
        top: '16px',
        right: '16px',
    };
});

export default VideoDialog;
